import { getApiConfig } from "../authHelper"
import { get, post, put } from "../api_helper"
import * as url from "../url_helper"
import axios from "axios"


export const getAllAnnouncementAlerts = () => {
    return get(`${url.ANNOUNCEMENT_ALERT}`, getApiConfig())
}

export const getActiveAlerts = () => {
    return get(`${url.ANNOUNCEMENT_ALERT}/active-alerts`, getApiConfig())
}

export const createAnnouncementAlert = data => {
    return post(`${url.ANNOUNCEMENT_ALERT}`, data, getApiConfig())
}

export const updateAnnouncementAlert = (id, data) => {
    return put(`${url.ANNOUNCEMENT_ALERT}/${id}`, data, getApiConfig())
}

export const uploadAnnouncementBanner = async file => {
    const formData = new FormData()
    formData.append("banner", file)
    const response = await axios.post(
        `${url.API_URL}${url.ANNOUNCEMENT_ALERT}/banner`,
        formData,
        getApiConfig(true)
    )
    return response?.data?.payload
}


